import { defaultClient as ApolloClient } from "../../../main";
import { GET_CLUB_INFO, GET_CLUB_TERMS } from "../../../graphql/clubs/clubsQ";
import {
  CLUB_MERGE,
  CLUB_DELETE,
  GROUP_MERGE,
  GROUP_DELETE,
  CLUB_TERM_MERGE,
  CLUB_TERM_DELETE
} from "../../../graphql/clubs/clubsM";

export const actions = {
  allClubs: async ({ commit }, payload) => {
    return ApolloClient.query({
      query: GET_CLUB_INFO,
      variables: payload
    })
      .then(({ data }) => {
        commit("setClubs", data.allClub.edges);
        commit("setClubInfo", data.allClub);
        // commented because this section causes athlete list disappear with direct link access from external websites
        // commit(
        //   "setGroupList",
        //   data.allClub.edges.reduce(function(all, item) {
        //     all = item.node.team.edges;
        //     return all;
        //   }, {})
        // );
        //console.log(data.allClub.edges);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(`Error in allCLubs action. Full info => ${err}`);
      });
  },

  allClub: ({ commit }, payload) => {
    //use ApolloClient to fire graphql query
    ApolloClient.query({
      query: GET_CLUB_INFO,
      variables: payload
    })
      .then(({ data }) => {
        //Get data from actions to state via mutations
        // commmit passes data from actions along to mutation function
        commit("setClubInfo", data.allClub);
        commit(
          "setGroupList",
          data.allClub.edges.reduce(function (all, item) {
            all = item.node.team.edges;
            return all;
          }, {})
        );
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  },
  addClub: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: CLUB_MERGE,
      variables: {
        clubId: payload.clubId,
        clubCode: payload.clubCode,
        clubName: payload.clubName,
        clubDesc: payload.clubDesc,
        password: payload.password,
        logo: payload.logo,
        email: payload.email,
        userId: payload.userId,
        visibility: payload.visibility,
        countryId: payload.countryId,
        createDate: payload.createDate,
        year: payload.year,
        latitude: payload.latitude,
        longitude: payload.longitude,
        updateSource: payload.updateSource
      },
      update: (cache, { data: { clubMerge } }) => {
        try {
          const data = cache.readQuery({
            query: GET_CLUB_INFO
          });
          clubMerge.node.team = {
            edges: [],
            __typename: "GroupConnection"
          };
          data.allClub.edges.push(clubMerge);
          cache.writeQuery({
            query: GET_CLUB_INFO,
            data
          });
        } catch (error) {
          console.error(
            `Error in update hook in addClub action. Full info => ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allClubs");
      })
      .catch(err => {
        console.error(err);
      });
  },

  editClub: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: CLUB_MERGE,
      variables: payload,
      // eslint-disable-next-line no-unused-vars
      update: (cache, { data: { clubMerge } }) => {
        try {
          const data = cache.readQuery({
            query: GET_CLUB_INFO
          });
          const getClub = data.allClub.edges.filter(
            club => +club.node.clubId === payload.clubId
          );
          const clubIndex = data.allClub.edges.indexOf(getClub[0]);
          if (clubIndex !== -1) {
            // eslint-disable-next-line no-unused-vars
            for (let [key, value] of Object.entries(
              data.allClub.edges[clubIndex].node
            )) {
              // eslint-disable-next-line no-unused-vars
              for (let [newKey, newValue] of Object.entries(payload)) {
                if (key === newKey) {
                  data.allClub.edges[clubIndex].node[key] = payload[newKey];
                }
              }
            }
          } else {
            console.error("No index for update hook in editClub action");
          }
          cache.writeQuery({
            query: GET_CLUB_INFO,
            data
          });
        } catch (error) {
          console.error(
            `Error in update hook in editClub action. Full info => ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allClubs");
      })
      .catch(err => {
        console.error(err);
      });
  },

  /****************CLUB DELETE**********************************/
  clubDelete: async ({ dispatch }, id) => {
    return ApolloClient.mutate({
      mutation: CLUB_DELETE,
      variables: {
        clubId: id
      },
      update: cache => {
        try {
          const data = cache.readQuery({
            query: GET_CLUB_INFO
          });
          data.allClub.edges = data.allClub.edges.filter(
            club => Number(club.node.clubId) !== id
          );
          cache.writeQuery({
            query: GET_CLUB_INFO,
            data
          });
        } catch (error) {
          console.error(
            `Error in update hook in clubDelete action. Full info => ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allClubs");
      })
      .catch(err => {
        console.error(`Error in clubDelete action. Full info => ${err}`);
      });
  },
  /*CLUB TEAM EDIT */
  // eslint-disable-next-line no-unused-vars
  groupMerge: ({ state, commit, dispatch }, payload) => {
    ApolloClient.mutate({
      mutation: GROUP_MERGE,
      variables: payload,
      update: (client, { data: { groupMerge } }) => { }, // eslint-disable-line
    })
      .then(({ data }) => {
        const indexClub = state.clubInfo.edges.findIndex(elem => {
          return elem.node.clubId == payload.clubId;
        });
        if (payload.teamId == 0) {
          state.clubInfo.edges[indexClub].node.team.edges.push(data.groupMerge);
        } else {
          const index = state.clubInfo.edges[
            indexClub
          ].node.team.edges.findIndex(
            group => group.node.teamId === data.groupMerge.node.teamId
          );

          state.clubInfo.edges[indexClub].node.team.edges[index].node =
            data.groupMerge.node;
        }
        dispatch("allClub");
      })
      .catch(err => {
        console.error(err);
      });
  },
  /*CLUB TEAM ADD NEW */
  // groupAdd: ({ state, commit }, payload) => {
  //   ApolloClient.mutate({
  //     mutation: GROUP_ADD_NEW,
  //     variables: payload,
  //     update: (client, { data: { groupMerge } }) => {}, // eslint-disable-line
  //   })
  //     .then(({ data }) => {
  //       const indexClub = state.clubInfo.edges.findIndex(elem => {
  //         return elem.node.clubId == payload.clubId;
  //       });
  //       state.clubInfo.edges[indexClub].node.team.edges.push(data.groupMerge);
  //       commit("setClubInfo", state.clubInfo);
  //     })
  //     .catch(err => {
  //       console.error(err);
  //     });
  // },
  groupDelete: ({ state, commit }, payload) => {
    ApolloClient.mutate({
      mutation: GROUP_DELETE,
      variables: payload
    })
      .then(() => {
        const clubIndex = state.clubInfo.edges.findIndex(elem => {
          return elem.node.clubId === payload.clubId.toString();
        });
        const index = state.clubInfo.edges[clubIndex].node.team.edges.findIndex(
          team => team.node.teamId === payload.teamId
        );
        state.clubInfo.edges[clubIndex].node.team.edges.splice(index, 1);
        commit("setClubInfo", state.clubInfo);
      })
      .catch(err => {
        console.error(err);
      });
  },
  clubTermMerge: async ({ dispatch, commit }, payload) => {
    return ApolloClient.mutate({
      mutation: CLUB_TERM_MERGE,
      variables: payload,
      update: (cache, { data }) => {
        try {
          console.log("Mutation response:", data);

          const newNode = data.clubTermMutate.edges.node;
          if (!newNode) {
            console.error("No node found in the mutation response");
            return;
          }

          const existingData = cache.readQuery({
            query: GET_CLUB_TERMS
          });

          let existingNodes = existingData.allClubTerms.edges.map(edge => edge.node);
          existingNodes = existingNodes.filter(item => item.seqNo !== newNode.seqNo);
          existingNodes.push(newNode);

          const newData = {
            allClubTerms: {
              ...existingData.allClubTerms,
              edges: existingNodes.map(node => ({ node }))
            }
          };

          cache.writeQuery({
            query: GET_CLUB_TERMS,
            data: newData
          });

          commit("setClubTerms", newData.allClubTerms.edges.map(edge => edge.node));
        } catch (error) {
          console.error(`Error in clubTermMerge update hook: ${error}`);
        }
      }
    })
      .then(() => {
        dispatch("allClubTerms");
      })
      .catch(err => {
        console.error(`Error in clubTermMerge action: ${err}`);
      });
  },
  clubTermDelete: async ({ dispatch, commit }, { seqNo }) => {
    return ApolloClient.mutate({
      mutation: CLUB_TERM_DELETE,
      variables: { seqNo },
      update: (cache, { data }) => {
        try {
          console.log("Delete Mutation Response:", data);

          const success = data.clubTermDelete.success;
          if (!success) {
            console.error("Deletion unsuccessful:", data.clubTermDelete.message);
            return;
          }

          const existingData = cache.readQuery({
            query: GET_CLUB_TERMS
          });

          const updatedNodes = existingData.allClubTerms.edges.filter(
            edge => edge.node.seqNo !== seqNo
          );

          const newData = {
            allClubTerms: {
              ...existingData.allClubTerms,
              edges: updatedNodes
            }
          };

          cache.writeQuery({
            query: GET_CLUB_TERMS,
            data: newData
          });

          commit("setClubTerms", newData.allClubTerms.edges.map(edge => edge.node));
        } catch (error) {
          console.error(`Error in clubTermDelete update hook: ${error}`);
        }
      }
    })
      .then(() => {
        dispatch("allClubTerms");
      })
      .catch(err => {
        console.error(`Error in clubTermDelete action: ${err}`);
      });
  },
  allClubTerms: async ({ commit }, filters = {}) => {
    return ApolloClient.query({
      query: GET_CLUB_TERMS,
      variables: filters,
      fetchPolicy: "network-only"
    })
      .then(({ data }) => {
        const terms = data.allClubTerms.edges.map(edge => edge.node);
        commit("setClubTerms", terms);
      })
      .catch(err => {
        console.error("Error in allClubTerms action:", err);
      });
  }

};
